<template>
  <a :href="searchUrl" class="goback-button">
      <i class="fas fa-chevron-left"></i>
      <span>Tillbaka till överblick</span>
  </a>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data: function () {
    return {
      searchParams: new URLSearchParams()
    }
  },
  methods: {
    makeSearchUrl: function () {
      const baseUrl = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' ? '/databas/sok/' : '/sok/'
      const searchUrl = this.activeTabIndex === 0 ? 'karta' : 'lista'
      const searchQuery = this.searchQuery

      _.each(this.filters, (f, key) => {
        if (_.size(f) > 0 || (typeof f === 'number' && f > 0)) {
          const v = typeof f === 'object' ? f.join(',') : f
          this.searchParams.set(key, v)
        } else {
          this.searchParams.delete(key)
        }
      })

      const params = this.searchParams.size > 0 ? '&' + this.searchParams.toString() : ''

      return baseUrl + searchUrl + '?q=' + searchQuery + params
    }
  },

  computed: {
    ...mapGetters({
      activeTabIndex: 'activeTabIndex'
    }),
    ...mapState({
      searchQuery: state => state.search.searchQuery,
      filters: state => state.search.filtered
    }),
    searchUrl () {
      return this.makeSearchUrl()
    }
  }

}
</script>
